import React, { Component } from 'react';
import {connect } from 'react-redux';
import {getMainData,addUser} from "../../Redux/ducks/mainReducer";
import {Alert,Label,Row,Col,FormGroup,Input, Button,Spinner,Table,Modal,
    ModalBody, ModalFooter,ModalHeader} from 'reactstrap'
import {checkRight,getName2} from "../../GeneralFunctions/general"
import ReactJsAlert from "reactjs-alert"
export class AddBusinessAssets extends Component {
    state={
        isSaving:false,
        isSaving2:false,
        mainData:null,
        msg:null,
        addCatMsg:null,
        btnDisabled:false,
        errorMsg:null,
        successMsg:null,
        isLoading:true,
        alertStatus :false, alertType :"error", alertTitle:null,
        name:"",des:"",modal:false,
        status:"",statusList:[],name1:"",des1:"",date1:"",updatedBy1:"",code:""

    }

    componentDidMount(){
        /**refresh categories */
        this.props.getMainData("ASSETS")
    }

    componentDidUpdate(prevProps){
        const{mainData,msg,mainDataStatus,addUserStatus} = this.props;
        
        if(mainDataStatus !== prevProps.mainDataStatus){
            if(mainDataStatus===true){
                this.setState({isSaving:false,mainData:mainData,isLoading:false})
            }else if(mainDataStatus===false){
                this.setState({isSaving:false,isLoading:false})
            }
        } 

        if(addUserStatus !== prevProps.addUserStatus){
            if(addUserStatus===true){
                this.setState({isSaving:false,isSaving2:false,successMsg:msg,btnDisabled:false,alertStatus :true, alertType :"success", alertTitle:msg})

                /**refresh categories */
                this.props.getMainData("ASSETS")
            }else if(addUserStatus===false){
                this.setState({isSaving:false,isSaving2:false,erroMsg:msg,btnDisabled:false,
                    alertStatus :true, alertType :"error", alertTitle:msg})
            }
        } 
    }

    setValue = e =>{
        this.setState({[e.target.name]:e.target.value})
    }

    /**add new user*/
    addCategory =(e)=>{
        if(checkRight(15)===false){
            this.setState({  alertStatus :true, alertType :"error", alertTitle:"Unauthorized to perform this action"})
        }else{
            const {name,des} = this.state;

            if(name===""){
                this.setState({  alertStatus :true, alertType :"error", alertTitle:"Fill in all feilds marked with a *"})
            }else{
                this.setState({erroMsg:null,isSaving:true,btnDisabled:true,successMsg:null})
                const data = new FormData();
                data.append("name",name);
                data.append("des",des);
    
                /**upload new user*/
                this.props.addUser(data,"ADD_ASSET")
            }
        }
    }

    viewUser=(e)=>{
  
        const selectedID = e.target.id;
        this.setState({modal:true,selectedID:selectedID})
        const myUserData =  this.state.mainData.assetsData
        let catList =[]
        myUserData.map((values, i) =>{
            if(parseInt(values.id) ===parseInt(selectedID)){
                if(parseInt(values.status)===1){
                    catList.push(<option key={i} value={values.status}>{"Active"}</option>)
                    catList.push(<option value={0}>{"Innactive"}</option>)
                }else{
                    catList.push(<option key={i} value={values.status}>{"Innactive"}</option>)
                    catList.push(<option value={1}>{"Active"}</option>)
                }

               
                this.setState({
                    status:values.status,
                    statusList:catList,
                    name1:values.name,
                    des1:values.des,
                    code:values.code,
                    date1:values.updated_at,
                    updatedBy1:values.added_by,
                })

            }
        });  
    }

    closeModal = ()=>{
        this.props.getMainData("ASSETS")
        this.setState({modal:false})
    }

    changeFee=(e)=>{
        if(checkRight(16)===false){
            this.setState({  alertStatus :true, alertType :"error", alertTitle:"Unauthorized to perform this action"})
        }else{
            const {name1,des1,status,selectedID} = this.state;
            if(name1===""){
                this.setState({  alertStatus :true, alertType :"error", alertTitle:"Fill in all feilds marked with a *"})
            }else{
                this.setState({isSaving2:true})
                const data = new FormData();
                data.append("updateID",selectedID);
                data.append("status",status);
                data.append("name",name1);
                data.append("des",des1);
            
                this.props.addUser(data,"UPDATE_ASSETS")
            }
        }
    }

    render() {
        
        let expenseCatDataList = [];
        const myUserData =  this.state.mainData
        var no =0
        if(myUserData !==null){
            if(myUserData.assetsData.length>0){
                myUserData.assetsData.map((values, i) =>{
                    no = no+1
                    expenseCatDataList.push(
                        <tr key={i}>

                            <th scope="row">{no}</th>
                            <td>{values.name}</td>
                          
                            <td>{values.code}</td>
                            {parseInt(values.status) ===1?<td><Label className="status1">Active</Label></td>:
                            <td><Label className="status2">Inactive</Label></td>
                            } 
                            <td>{getName2(myUserData.staffData,values.added_by,"STAFF")}</td>
                            <td>{values.updated_at}</td>
                            <td><Button id={values.id} onClick={this.viewUser}>Edit</Button></td>
                        </tr>
                    )
                });
            }else{
                expenseCatDataList.push(
                    <div>
                        <br/><Alert color="primary">No laon types added yet</Alert>
                    </div>
                )
            }
        }
        return (
            <div>
                <div className="container">
                    <div className="block-header">
                    <h4>ADD BUSINESS ASSETS</h4>
                    </div>
                    <Row className="mainWrraper">
                        <ReactJsAlert autoCloseIn ={600000} status={this.state.alertStatus} type={this.state.alertType} title={this.state.alertTitle} Close={() => this.setState({ alertStatus: false })}/>
                        {this.state.modal ? 
                        <Modal  isOpen={this.state.modal} className="modalWrapper modal-dialog modal-lg">
                            <ModalHeader toggle={this.closeModal}>Update Business Assets</ModalHeader>
                            <ModalBody className="modalBodyWrapper">
                                <Col xs="12" >
                                <FormGroup>
                                    <Label for="username">Name*</Label>
                                    <Input type="text" onChange={this.setValue} value={this.state.name1} name="name1" />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="username">Description</Label>
                                    <Input type="textarea" onChange={this.setValue} value={this.state.des1} name="des1" />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="username">Code</Label>
                                    <Input type="text"  disabled  value={this.state.code}/>
                                </FormGroup>
                               
                                <FormGroup>
                                    <Label for="username">Updated By</Label>
                                    <Input type="text"  disabled  value={getName2(this.state.mainData.staffData,this.state.updatedBy1,"STAFF")} />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="username">Updated At</Label>
                                    <Input type="text" disabled   value={this.state.date1}/>
                                </FormGroup>
                                

                                <FormGroup>
                                    <Label for="gender">Select Status</Label>
                                    <Input type="select" onChange={this.setValue} name="status">
                                        {this.state.statusList}
                                    </Input>
                                </FormGroup>

                                </Col>
                            
                    
                                <Col xs="12" >
                                    {this.state.isSaving2?<div><Spinner className="mySpinner" /><Spinner className="mySpinner" type="grow"/>{'Updating...'}</div>:null}
                                    <Button onClick={this.changeFee} disabled={this.state.btnDisabled? "disabled":null} className="btn btn-block btn-lg btn-danger">Update Business Assets</Button>
                                </Col>
                            </ModalBody>
                        </Modal>
                        :null}
                        
                        
                        
                        
                        <Col xs="12" md="6">
                            <FormGroup>
                                <Label for="username">Asset Name*</Label>
                                <Input type="text" onChange={this.setValue} value={this.state.name} name="name" />
                            </FormGroup>
                        </Col>
                        <Col xs="12" md="6">
                            <FormGroup>
                                <Label for="username">Description</Label>
                                <Input type="textarea" rows="1" onChange={this.setValue} value={this.state.rate} name="des" />
                            </FormGroup>
                        </Col>
                        
                  
                        <Col xs="12" >
                        
                            {this.state.isSaving?<div><Spinner className="mySpinner" /><Spinner className="mySpinner" type="grow"/>{'Saving...'}</div>:null}
        
                            <Button onClick={this.addCategory} disabled={this.state.btnDisabled? "disabled":null} className="btn btn-block btn-lg btn-danger">Add Asset</Button>
                        </Col>

                       

                        <Col xs="12" md="12" className="tableWrapper">
                            <div className="table-container">
                                <Table striped responsive>
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <th>Loan Type</th>
                                            <th>Code</th>
                                            <th>Status</th>
                                            <th>Updated By</th>
                                            <th>Updated At</th>
                                        
                                            <th>Edit</th>
                                        </tr>
                                    </thead>
                                    {this.state.isLoading?
                                    <tbody>
                                        <tr>
                                            <td colSpan="8">
                                                <Spinner className="mySpinner" /><Spinner className="mySpinner" type="grow"/>{'Loading...'}
                                            </td>
                                        </tr>
                                    </tbody>:
                                    
                                    <tbody>
                                        {expenseCatDataList}
                                    </tbody>}
                                </Table>
                            </div>

                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state =>({
    mainDataStatus : state.mainReducer.dataStatus,
    msg : state.mainReducer.msg,
    mainData : state.mainReducer.mainData,
    addUserStatus:state.mainReducer.addUserStatus,
});
export default connect(
    mapStateToProps, {getMainData,addUser}
)(AddBusinessAssets)
